module.exports = __webpack_public_path__ + "img/fiche.10effde.PNG";